// extracted by mini-css-extract-plugin
module.exports = {"container":"selfRateInquirys_container__5FNHJ"};